export * from './item-structure-shortcut.component';
